module.exports = __webpack_public_path__ + "img/dale.d36a9bef.jpg";